module.exports = __webpack_public_path__ + "img/prizes-icon.bedf147e.svg";